var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"fi-pagination"},[_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.pages,"per-page":1,"limit":_vm.limit},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }